// ============================================
// POS LAYOUT - Full-screen layout for POS
// Removes sidebar for touch-optimized experience
// ============================================

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';

export function POSLayout() {
  return (
    <div data-testid="pos-layout" className="h-screen flex flex-col bg-gray-100">
      {/* Full-screen POS Content */}
      <main className="flex-1 overflow-hidden">
        <Outlet />
      </main>
      
      <Toaster position="top-right" />
    </div>
  );
}
